module.exports = __webpack_public_path__ + "static/jeanine-002-4f83dd7b2d06208d1c4b0964b137f57b.jpg";